enum ProductCondition {
  CONDITION_GOOD = "Goed",
  CONDITION_ACTION_REQUIRED = "Actie vereist",
  CONDITION_REJECTED = "Afgekeurd",
  CONDITION_UNKNOWN = "Onbekend",
}

export default ProductCondition;
